var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallToSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 240,
    viewBox: "0 0 280 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M140 239C217.32 239 280 230.941 280 221C280 211.059 217.32 203 140 203C62.6801 203 0 211.059 0 221C0 230.941 62.6801 239 140 239Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253 39H60V172H253V39Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161 52H77V155H161V52Z",
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.844 67.6699H123.68V70.2464H131.844V67.6699Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.033 67.6699H134.621V70.2464H155.033V67.6699Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.01 75.9976H123.68V78.574H144.01V75.9976Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.031 75.9976H146.621V78.574H155.031V75.9976Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.034 84.3267H133.887V86.9031H155.034V84.3267Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.6 84.3267H123.68V86.9031H131.6V84.3267Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.929 92.6455H123.68V95.222H147.929V92.6455Z",
    fill: "#C9C9C9"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M116 68H84V103H116V68Z",
    fill: "#C9C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161 52H77V61H161V52Z",
    fill: "#0D9F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M155 112H128V114H155V112Z",
    fill: "#C9C9C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M124 112H84V114H124V112Z",
    fill: "#C9C9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M155 121H136V123H155V121Z",
    fill: "#C9C9C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M132 121H84V123H132V121Z",
    fill: "#C9C9C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M108 130H84V132H108V130Z",
    fill: "#C9C9C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M155 130H115V132H155V130Z",
    fill: "#C9C9C9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M145 139H84V142H145V139Z",
    fill: "#C9C9C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.17 77.719C105.17 77.719 106.4 82.9897 105.865 86.6464C105.813 87 105.684 87.341 105.484 87.6497C105.284 87.9584 105.018 88.2287 104.702 88.4451C104.385 88.6614 104.024 88.8196 103.638 88.9106C103.253 89.0015 102.852 89.0234 102.457 88.9749C100.41 88.7059 97.7626 87.8148 96.6829 85.0576L94.3169 80.5603C93.9392 79.6183 93.8981 78.5943 94.1992 77.6304C94.5003 76.6665 95.1287 75.8103 95.9975 75.1804C99.0113 72.6753 104.645 74.4574 105.17 77.719Z",
    fill: "#F4A28C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7871 81L94 100L105 99.6651L101.15 85.9786L94.7871 81Z",
    fill: "#F4A28C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 77.6016C101.659 77.8681 99.7896 77.9379 97.9305 77.8094C98.5595 78.502 98.9558 79.348 99.071 80.2444C99.1863 81.1407 99.0156 82.0486 98.5797 82.8572C98.1715 83.6436 97.4794 84.2754 96.6216 84.6449C95.7638 85.0144 94.7932 85.0986 93.8755 84.8832L93.0569 77.792C92.9069 76.7816 93.0547 75.7525 93.4851 74.8127C93.9155 73.8728 94.6125 73.0567 95.5032 72.4499C96.2784 71.924 97.0892 71.4439 97.9305 71.0126C100.038 69.9563 103.453 70.9606 105.269 69.3675C105.451 69.2079 105.676 69.0947 105.92 69.0391C106.164 68.9834 106.42 68.9873 106.662 69.0502C106.904 69.1131 107.124 69.2329 107.3 69.3978C107.477 69.5628 107.604 69.7672 107.668 69.9909C108.289 72.1035 108.308 75.5409 105.297 77.0647C104.735 77.3353 104.128 77.5168 103.5 77.6016Z",
    fill: "#FFD200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99 83.0272C99 83.0272 98.687 80.6106 97.0117 81.0544C95.3364 81.4983 95.769 84.9408 98.1071 85L99 83.0272Z",
    fill: "#F4A28C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.731 81L107.721 82.9272C107.84 83.0337 107.925 83.166 107.968 83.311C108.011 83.456 108.011 83.6085 107.967 83.7533C107.923 83.8982 107.837 84.0302 107.718 84.1363C107.599 84.2423 107.451 84.3186 107.288 84.3576L105 85L105.731 81Z",
    fill: "#F4A28C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M101.802 89.5106C100.397 89.3495 99.0749 88.8243 98 88C98 88 98.5893 91.2249 103 94L101.802 89.5106Z",
    fill: "#CE8172"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4983 97H103.493C104.085 97 104.671 97.1269 105.217 97.3734C105.764 97.6199 106.261 97.9813 106.68 98.4368C107.098 98.8923 107.43 99.4331 107.657 100.028C107.883 100.623 108 101.261 108 101.905V103H92V101.905C92 101.261 92.1166 100.623 92.3431 100.028C92.5696 99.4331 92.9016 98.8923 93.3202 98.4368C93.7388 97.9813 94.2357 97.6199 94.7825 97.3734C95.3294 97.1269 95.9155 97 96.5074 97H96.4983Z",
    fill: "#0D9F3F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M246 76H177V161H246V76Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M239 68H170V152H239V68Z",
    fill: "#E6E6E6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.151 81.0781H208.492V83.1738H215.151V81.0781Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 81.0781H217.422V83.1738H234.078V81.0781Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.076 87.8735H208.492V89.9692H225.076V87.8735Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.065 87.8735H227.207V89.9692H234.065V87.8735Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.075 94.668H216.82V96.7636H234.075V94.668Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.951 94.668H208.492V96.7636H214.951V94.668Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.278 101.462H208.492V103.558H228.278V101.462Z",
    fill: "#C9C9C9"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M202 81H176V110H202V81Z",
    fill: "#C9C9C9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239 68H170V75H239V68Z",
    fill: "#0D9F3F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M234 117H212V119H234V117Z",
    fill: "#C9C9C9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M209 117H176V119H209V117Z",
    fill: "#C9C9C9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M234 125H218V126H234V125Z",
    fill: "#C9C9C9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M215 125H176V126H215V125Z",
    fill: "#C9C9C9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M196 132H176V134H196V132Z",
    fill: "#C9C9C9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M234 132H201V134H234V132Z",
    fill: "#C9C9C9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M227 140H176V142H227V140Z",
    fill: "#C9C9C9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.355 88.4693C195.918 91.2106 196.114 94.0148 195.937 96.8079C195.892 97.1376 195.783 97.4553 195.616 97.7427C195.448 98.0302 195.226 98.2818 194.961 98.4832C194.697 98.6846 194.395 98.8319 194.074 98.9166C193.753 99.0013 193.418 99.0217 193.088 98.9768C192.019 98.8984 190.995 98.5127 190.14 97.8662C189.284 97.2196 188.633 96.3395 188.265 95.3315L186.253 91.1395C185.947 90.2586 185.918 89.3047 186.17 88.4067C186.422 87.5087 186.944 86.7099 187.664 86.1181C190.24 83.7487 194.881 85.4347 195.355 88.4693Z",
    fill: "#F4A28C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M186.64 92L186 109L195 108.708L191.856 96.4499L186.64 92Z",
    fill: "#F4A28C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M195.465 92L196.821 93.4403C196.899 93.522 196.953 93.6215 196.981 93.7296C197.008 93.8377 197.006 93.9508 196.977 94.0582C196.947 94.1656 196.89 94.2639 196.811 94.3438C196.732 94.4237 196.633 94.4826 196.524 94.5149L195 95L195.465 92Z",
    fill: "#F4A28C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M192.035 98.5099C190.914 98.345 189.859 97.8205 189 97C189 97 189.469 100.227 193 103L192.035 98.5099Z",
    fill: "#CE8172"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194.92 86.0084C194.92 86.0084 194.92 91.5757 189.555 91.7029C189.649 91.7029 189.366 94.7817 189.347 94.9361C189.065 97.0704 189.64 99.2592 189.593 101.439C189.616 101.816 189.535 102.192 189.357 102.529C189.059 102.888 188.644 103.141 188.178 103.246C185.592 104.062 182.831 104.219 180.164 103.7C179.788 103.679 179.423 103.569 179.102 103.38C178.781 103.191 178.513 102.929 178.321 102.617C178.129 102.305 178.02 101.953 178.002 101.59C177.985 101.228 178.06 100.867 178.221 100.54C178.427 99.2946 178.778 98.0759 179.268 96.9069C179.702 95.8534 180.362 94.8998 180.786 93.8644C181.721 91.526 182.354 89.0858 182.672 86.5987C182.74 85.8404 182.904 85.0931 183.162 84.3736C183.619 83.3805 184.321 82.5104 185.208 81.8397C186.09 81.2053 187.187 80.9135 188.282 81.0223C194.005 80.9133 195.373 83.2838 194.92 86.0084Z",
    fill: "#FFD200"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M190 93.5518C190 93.5518 189.793 91.7306 188.675 92.0341C187.557 92.3376 187.849 94.974 189.388 95L190 93.5518Z",
    fill: "#F4A28C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M196.936 110H183V109.735C183 108.479 183.482 107.275 184.339 106.387C185.197 105.499 186.36 105 187.572 105H192.428C193.64 105 194.803 105.499 195.661 106.387C196.518 107.275 197 108.479 197 109.735V110H196.936Z",
    fill: "#0D9F3F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M57.2024 104.402C57.8462 104.122 58.5059 103.882 59.1782 103.681C62.4713 102.801 65.8674 102.368 69.2755 102.394C74.7384 102.239 80.948 102.467 86.1196 104.392C91.018 106.217 93.9042 110.779 95.6706 115.477C96.226 116.946 96.4718 117.995 98.3201 117.74C104.432 116.885 110.21 114.424 115.064 110.605C119.443 107.139 123.258 102.476 128.658 101.099C129.079 100.967 129.53 100.967 129.951 101.099C130.67 101.373 130.925 102.267 130.988 103.033C131.104 105.782 130.355 108.497 128.849 110.797C127.35 113.076 125.646 115.214 123.759 117.183C118.16 123.451 112.833 130.175 105.549 134.518C104.437 135.024 103.501 135.854 102.863 136.899C101.561 139.8 102.809 168.228 102.863 173H70.0858L54.9353 133.961C52.2038 126.973 45.8304 116.627 50.9018 109.383C52.4897 107.159 54.6744 105.432 57.2024 104.402Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M232.937 209.31C232.937 209.31 224.773 207.014 223 199.207C223 199.207 235.644 196.587 236 210L232.937 209.31Z",
    fill: "#0D9F3F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M234.584 208.982C234.584 208.982 229.223 199.172 233.945 190C233.945 190 242.989 196.641 238.971 209L234.584 208.982Z",
    fill: "#0D9F3F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M235 208.973C235 208.973 238.19 198.904 247.83 197C247.83 197 249.627 203.539 241.541 209L235 208.973Z",
    fill: "#0D9F3F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M230 209L231.703 220.955L242.419 221L244 209.063L230 209Z",
    fill: "#24285B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20 175C20 175 20.7469 185.238 25.975 182.55C31.2032 179.863 24.6565 175 24.6565 175H20Z",
    fill: "#F4A28C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6857 105C36.6857 105 0.0646276 130.717 19.8798 175H25.3511C25.3511 175 22.4786 142.905 36.6857 127.664C50.8928 112.422 36.6857 105 36.6857 105Z",
    fill: "#0D9F3F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.6857 105C36.6857 105 0.0646276 130.717 19.8798 175H25.3511C25.3511 175 22.4786 142.905 36.6857 127.664C50.8928 112.422 36.6857 105 36.6857 105Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.212 90.266L49 100.076L42.3804 105L40 88L46.212 90.266Z",
    fill: "#F4A28C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4644 82.8605C37.7465 82.1346 38.1914 81.498 38.758 81.0095C39.3246 80.521 39.9947 80.1963 40.7064 80.0653C41.4181 79.9342 42.1486 80.0012 42.8304 80.2599C43.5122 80.5186 44.1234 80.9607 44.6076 81.5456C46.9371 84.2693 49.7652 88.5991 46.5675 90.9378C41.6936 94.5444 37.2237 87.8102 37.2237 87.8102C36.8583 86.1701 36.942 84.4489 37.4644 82.8605Z",
    fill: "#F4A28C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9457 84.5582C41.9457 84.5582 40.0177 82.9239 39.1423 85.248C38.2669 87.5721 41.6748 88.7076 42.6857 87.5296C43.6966 86.3517 41.9457 84.5582 41.9457 84.5582Z",
    fill: "#F4A28C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2209 148.25L9.23828 157.523L15.7044 182.612L51.6869 173.338L45.2209 148.25Z",
    fill: "#FFD200"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M28 152.836L33.9624 169.023L33.6432 177L42.1972 174.991L46 160.614L35.6338 151L28 152.836Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8554 109.419C34.9581 106.948 36.5739 104.746 38.5931 102.962C40.6123 101.179 42.9875 99.8553 45.5575 99.0818C55.4593 96.0698 73.7597 99.3639 79.3317 108.755C86.9651 121.604 75.794 162.443 75.794 162.443L42.479 165C42.479 165 24.0976 131.54 33.8554 109.419Z",
    fill: "#0D9F3F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M75 163L70.7304 220H63.971L57.9392 175.713L43 165.568L75 163Z",
    fill: "#24285B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3638 165L33 220H40.2761L56 174.311L42.3638 165Z",
    fill: "#24285B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M47.9782 98C47.9782 98 32.6116 148.929 77 152.304L74.9074 162.382L42.0993 165C42.0993 165 30.519 146.303 31.0155 120.035C31.0155 120.035 31.2904 107.048 40.184 101.302C42.5241 99.6432 45.1813 98.5176 47.9782 98Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6753 220L30.4187 223.236C30.2486 223.351 30.1199 223.522 30.0525 223.72C29.985 223.919 29.9825 224.136 30.0454 224.336C30.1083 224.536 30.2331 224.71 30.4006 224.83C30.568 224.95 30.7688 225.009 30.9721 224.999H38.0721C38.3182 224.999 38.5542 224.898 38.7282 224.717C38.9022 224.537 39 224.293 39 224.038V220.026L34.6753 220Z",
    fill: "#0D9F3F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9712 220L74.5427 223.236C74.7329 223.356 74.8747 223.529 74.9469 223.729C75.019 223.928 75.0177 224.144 74.9429 224.342C74.8682 224.541 74.7242 224.713 74.5325 224.831C74.3408 224.949 74.1118 225.008 73.8799 224.999H68.0899C67.2704 224.999 66.4845 224.705 65.905 224.18C65.3255 223.656 65 222.945 65 222.204V220.026L69.9712 220Z",
    fill: "#0D9F3F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7239 89.739C37.7239 89.739 39.4279 92.7578 42.2427 91.819C45.0575 90.8803 43.0335 84.3826 43.0335 84.3826C43.0335 84.3826 46.4414 79.5783 45.9519 75.7773C45.8719 75.327 45.6468 74.9135 45.3095 74.5971C44.9722 74.2807 44.5403 74.0779 44.0768 74.0183C43.6133 73.9587 43.1425 74.0454 42.733 74.2658C42.3234 74.4862 41.9967 74.8288 41.8003 75.2435C41.4784 75.8242 41.0067 76.3125 40.4319 76.6596C39.8571 77.0068 39.1994 77.2008 38.5241 77.2223C33.7323 77.7376 29.3359 85.1373 37.7239 89.739Z",
    fill: "#24285B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1684 100.545C69.1684 100.545 91.3179 113.121 98.2195 113.121C105.121 113.121 122.343 100 122.343 100L126 107.664C126 107.664 111.374 130.692 98.3018 128.901C85.2297 127.109 65 115.595 65 115.595L69.1684 100.545Z",
    fill: "#0D9F3F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M123 100.551C123 100.551 126.265 94.0267 127.348 94.1074C128.43 94.1882 128.014 96.2883 128.014 96.2883C128.014 96.2883 131.511 92.492 132.51 93.0574C133.509 93.6228 133.592 102.104 126.682 108L123 100.551Z",
    fill: "#F4A28C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M253 27H60V39H253V27Z",
    fill: "#24285B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 36C80.433 36 82 34.6569 82 33C82 31.3431 80.433 30 78.5 30C76.567 30 75 31.3431 75 33C75 34.6569 76.567 36 78.5 36Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M88 36C89.6569 36 91 34.6569 91 33C91 31.3431 89.6569 30 88 30C86.3431 30 85 31.3431 85 33C85 34.6569 86.3431 36 88 36Z",
    fill: "#0D9F3F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36C98.6569 36 100 34.6569 100 33C100 31.3431 98.6569 30 97 30C95.3431 30 94 31.3431 94 33C94 34.6569 95.3431 36 97 36Z",
    fill: "#FFD200"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239 52H172V59H239V52Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallToSetup);
export default __webpack_public_path__ + "static/media/call_to_setup.a3e65cd9fb7ac2bb2f0c726f29f017b7.svg";
export { ForwardRef as ReactComponent };